export default "__VITE_ASSET__2yxNNqCZ__"